import React, { Component } from 'react';


export default class LeaderSpotlightIntro extends Component {
  constructor(props) {
    super(props);
  }

  setParentWhichPageState = (page) => {
    this.props.setWhichPage(page);
  }

  render() {

    return(
      <div>
        <div className="sharedStory-header"><h1 className="page-heading">Women Making a Difference</h1></div>
        <div className="leaderSpotlightIntroWrapper">
          <p>Are you the leader of an organization that empowers women and girls? If you are, we encourage you to share your story with our WorldWideWomen community of over 100,000 members and followers from around the world. Our Leader Spotlight series highlights the achievements of women leaders around the world who have started their own organizations or lead an organization that supports women and girls.</p>

          <p>Please tell us about your organization and share the experiences and aspirations that have contributed to your success.  The stories we choose will be featured on our website, in our weekly newsletter, and on our social media platforms. Our goal is to showcase the many amazing women and organizations that are working tirelessly to support us and improve our lives. Thank you for being a part of the WorldWideWomen global community!
          </p>

          <div onClick={this.setParentWhichPageState.bind(this, 'form')} style={{
            cursor: 'pointer',
            backgroundColor: '#ec052f',
            color: 'white',
            fontSize: '2.0rem',
            width: '20.0rem',
            margin: '0 auto 6.0rem auto',
            textAlign: 'center',
            padding: '1.0rem',
            fontWeight: 'bold',
            }} className="leaderSpotlightBtn">Share your story</div>
        </div>
        
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/leaderStory/LeaderSpotlightIntro.jsx